/**
 * Product Video Image Swipe for Mobile/Tablet
 * Enables left-to-right swiping to swap video icon and image on smaller screens
 */
(function() {
  'use strict';

  let isMobile = false;
  let touchStartX = 0;
  let touchEndX = 0;
  let minSwipeDistance = 50; // Minimum distance for a swipe

  /**
   * Check if device is mobile/tablet
   */
  function checkMobile() {
    return window.innerWidth <= 1024;
  }

  /**
   * Swap video icon and image order
   */
  function swapVideoElements(mediaItem, swapToImageFirst) {
    const icon = mediaItem.querySelector('.product__media-icon--video');
    const imageContainer = mediaItem.querySelector('.product__media--video');
    
    if (!icon || !imageContainer) return;

    // Add swap class for CSS
    if (swapToImageFirst) {
      mediaItem.classList.add('product__media-item--swapped', 'brator-product-img-tab-item--swapped');
      icon.style.order = '2';
      icon.style.marginLeft = 'auto';
      icon.style.marginRight = '0';
      imageContainer.style.order = '1';
      imageContainer.style.flex = '1 1 auto';
    } else {
      mediaItem.classList.remove('product__media-item--swapped', 'brator-product-img-tab-item--swapped');
      icon.style.order = '1';
      icon.style.marginLeft = '0';
      icon.style.marginRight = 'auto';
      imageContainer.style.order = '2';
      imageContainer.style.flex = '1 1 auto';
    }
  }

  /**
   * Initialize swipe functionality for a media item
   */
  function initSwipeForItem(mediaItem) {
    const icon = mediaItem.querySelector('.product__media-icon--video');
    const imageContainer = mediaItem.querySelector('.product__media--video');
    
    if (!icon || !imageContainer) return;

    // Check if already initialized
    if (mediaItem.dataset.swipeInitialized === 'true') return;
    mediaItem.dataset.swipeInitialized = 'true';

    // Make container touchable
    const touchableElement = imageContainer.querySelector('img') || imageContainer;

    // Touch start
    touchableElement.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    // Touch end
    touchableElement.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe(mediaItem);
    }, { passive: true });

    // Mouse events for desktop testing
    let mouseStartX = 0;
    touchableElement.addEventListener('mousedown', function(e) {
      if (isMobile) {
        mouseStartX = e.clientX;
      }
    });

    touchableElement.addEventListener('mouseup', function(e) {
      if (isMobile && mouseStartX !== 0) {
        touchEndX = e.clientX;
        touchStartX = mouseStartX;
        handleSwipe(mediaItem);
        mouseStartX = 0;
      }
    });
  }

  /**
   * Handle swipe gesture
   */
  function handleSwipe(mediaItem) {
    const swipeDistance = touchEndX - touchStartX;
    const isSwapped = mediaItem.classList.contains('product__media-item--swapped') || 
                      mediaItem.classList.contains('brator-product-img-tab-item--swapped');

    // Swipe right (positive) - show image first (left side)
    if (swipeDistance > minSwipeDistance) {
      if (!isSwapped) {
        swapVideoElements(mediaItem, true);
      }
    }
    // Swipe left (negative) - show icon first (left side)
    else if (swipeDistance < -minSwipeDistance) {
      if (isSwapped) {
        swapVideoElements(mediaItem, false);
      }
    }
  }

  /**
   * Find parent container that holds both icon and image
   */
  function findParentContainer(element) {
    // Look for product__media-item or brator-product-img-tab-item
    let parent = element;
    while (parent && parent !== document.body) {
      if (parent.classList && (
        parent.classList.contains('product__media-item') ||
        parent.classList.contains('brator-product-img-tab-item') ||
        parent.classList.contains('js-tabs__content')
      )) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return null;
  }

  /**
   * Initialize all video media items
   */
  function initVideoSwipe() {
    if (!checkMobile()) {
      isMobile = false;
      // Reset all swaps on desktop
      document.querySelectorAll('.product__media-item--swapped, .brator-product-img-tab-item--swapped').forEach(function(item) {
        item.classList.remove('product__media-item--swapped', 'brator-product-img-tab-item--swapped');
        const icon = item.querySelector('.product__media-icon--video');
        const imageContainer = item.querySelector('.product__media--video');
        if (icon) icon.style.order = '';
        if (imageContainer) imageContainer.style.order = '';
      });
      return;
    }

    isMobile = true;
    
    // Find all video icons first
    const videoIcons = document.querySelectorAll('.product__media-icon--video');
    const processedContainers = new Set();

    videoIcons.forEach(function(icon) {
      // Find the parent container
      const parentContainer = findParentContainer(icon);
      if (!parentContainer || processedContainers.has(parentContainer)) {
        return;
      }

      processedContainers.add(parentContainer);

      // Check if it has the image container
      const imageContainer = parentContainer.querySelector('.product__media--video');
      if (!imageContainer) {
        return;
      }

      // Ensure flex layout
      const computedStyle = window.getComputedStyle(parentContainer);
      if (computedStyle.display !== 'flex' && computedStyle.display !== 'grid') {
        parentContainer.style.display = 'flex';
        parentContainer.style.flexDirection = 'row';
        parentContainer.style.alignItems = 'center';
        parentContainer.style.gap = '10px';
        parentContainer.style.position = 'relative';
      }

      // Initialize swipe
      initSwipeForItem(parentContainer);
      
      // Set initial state (image first on mobile)
      if (!parentContainer.classList.contains('product__media-item--swapped') && 
          !parentContainer.classList.contains('brator-product-img-tab-item--swapped')) {
        swapVideoElements(parentContainer, true);
      }
    });
  }

  /**
   * Handle window resize
   */
  function handleResize() {
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(function() {
      initVideoSwipe();
    }, 250);
  }

  /**
   * Initialize on page load
   */
  function init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initVideoSwipe, 500);
      });
    } else {
      setTimeout(initVideoSwipe, 500);
    }

    // Re-initialize on resize
    window.addEventListener('resize', handleResize);

    // Re-initialize on dynamic content updates (Shopify theme editor)
    if (typeof Shopify !== 'undefined') {
      document.addEventListener('shopify:section:load', function() {
        setTimeout(initVideoSwipe, 500);
      });
      
      document.addEventListener('shopify:section:select', function() {
        setTimeout(initVideoSwipe, 300);
      });
    }

    // Re-initialize when product variant changes
    document.addEventListener('variant:change', function() {
      setTimeout(initVideoSwipe, 200);
    });

    // Use MutationObserver to watch for new video elements
    const observer = new MutationObserver(function(mutations) {
      let shouldReinit = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          Array.from(mutation.addedNodes).forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('product__media-item') ||
                node.classList.contains('brator-product-img-tab-item') ||
                node.querySelector('.product__media-icon--video')
              )) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      if (shouldReinit) {
        setTimeout(initVideoSwipe, 300);
      }
    });

    // Observe the product media container
    const productMediaContainer = document.querySelector('.brator-product-img-tab-list, .product__media-list');
    if (productMediaContainer) {
      observer.observe(productMediaContainer, {
        childList: true,
        subtree: true
      });
    }
  }

  // Start initialization
  init();
})();

